import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import { CHATTER_LESSON_PLANS_ADD, CHATTER_LESSON_PLANS_EDIT } from "config/paths";
import { useDeleteLessonMutation, useGetChatterLessonTagsQuery, useGetLessonListQuery } from "store/services/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ShowAttachedFilesPop from "components/Modals/ViewAttachedFilesPop";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { successMessageToast } from "helpers/common";
import ShareLessonPop from "components/Modals/ShareLessonPop";
import parse from "html-react-parser";

const ChatterLessonPlan = () => {

  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", status: "", sort: { column: "id", direction: "desc" } });

  const { data: lessonTags, isLoading: lessonTagsLoading } = useGetChatterLessonTagsQuery()
  const { data, isLoading, isError, isFetching } = useGetLessonListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [files, setFiles] = useState([]);
  const [showAttachedFileModal, setShowAttachedFileModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [showShareModal, setShowShareModal] = useState(null);

  const [deleteLesson, { isLoading: deleteLessonLoading }] = useDeleteLessonMutation();

  const resetFilter = () => {
    setFilter({ search: "", status: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {

      setShowDeleteModal(false);

      const result = await deleteLesson(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting group", err);
    };
  };

  const column = [
    {
      head: "Lesson Name",
      accessor: "LessonName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold text-capitalize">{item?.title || "--"}</h6>
        </div>
      ),
    },
    {
      head: "Description",
      accessor: "description",
      component: (item, ind) => (
        <p className="lesson-plans-des">{item?.description ? parse(item?.description || "") : "--"}</p>
      ),
    },
    // {
    //   head: "Tags",
    //   accessor: "Tags",
    //   component: (item, ind) => (
    //     <div className="text-capitalize">{item?.tag || "--"}</div>
    //   ),
    // },
    {
      head: "Tags",
      accessor: "tag",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex area-pills flex-wrap gap-2 mt-2">
          {item?.lessonTags?.map((tag) => (
            <button
              key={tag?.tag_id}
              type="button"
              // variant={values.tags?.includes(tag?.value) ? "primary" : "outline-secondary"}
              className={"select-liberary-btn proxima-regular"}
            >
              {tag?.tags?.title}
            </button>
          ))}
        </div>
      )
    },
    {
      head: "Attachments",
      accessor: "FilesName",
      component: (item, ind) => (
        <div>
          <Button className="d-flex align-items-center justify-center rounded-pill  fw-sbold border"
            style={{ fontFamily: "Merriweather", color: "#AEAEAE" }}
            variant="transparent"
            onClick={() => {

              if (item?.files?.length) {
                setFiles(item?.files || []);
                setShowAttachedFileModal(true);
              }
            }}
          >
            {item?.files?.length || 0} Files
            <span className="icn ms-1">{Icon}</span>
          </Button>
        </div>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Edit"}
            component={<Button
              onClick={() => navigate(CHATTER_LESSON_PLANS_EDIT.replace(":id", item?.id))}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#EBFFEB" />
                <mask
                  id="mask0_0_4552"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="4"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="4" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_0_4552)">
                  <path
                    d="M6.5 21.9997V19.7497H21.5V21.9997H6.5ZM9.5 16.3099H10.4274L16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L9.5 15.3825V16.3099ZM8.375 17.4349V14.9036L16.7823 6.50792C16.8909 6.3993 17.0142 6.31711 17.1523 6.26136C17.2901 6.20561 17.4336 6.17773 17.5828 6.17773C17.732 6.17773 17.8765 6.20561 18.0163 6.26136C18.156 6.31711 18.2841 6.40317 18.4004 6.51955L19.3019 7.43249C19.4183 7.54111 19.5024 7.66555 19.5543 7.8058C19.6062 7.94592 19.6321 8.0908 19.6321 8.24042C19.6321 8.38067 19.6058 8.52011 19.5532 8.65873C19.5006 8.79748 19.4168 8.9243 19.3019 9.03917L10.9062 17.4349H8.375ZM16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L16.6524 10.0963Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />
          <CommonToolTip
            text={"Share"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {

                setCurrentEntry(item);
                setShowShareModal(true);
              }}
            >
              {ShareIcon}
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {

                if (!deleteLessonLoading || isFetching) {
                  setShowDeleteModal(true);
                  setCurrentEntry(item);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#FFE3E5" />
                <mask
                  id="mask0_26_18856"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="5"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_26_18856)">
                  <path
                    d="M10.4808 20.3753C10.1068 20.3753 9.78731 20.2429 9.52231 19.978C9.25744 19.713 9.125 19.3935 9.125 19.0195V9.50029H8.375V8.37529H11.75V7.71191H16.25V8.37529H19.625V9.50029H18.875V19.0195C18.875 19.3984 18.7438 19.719 18.4813 19.9815C18.2188 20.244 17.8981 20.3753 17.5192 20.3753H10.4808ZM17.75 9.50029H10.25V19.0195C10.25 19.0869 10.2716 19.1422 10.3149 19.1854C10.3581 19.2287 10.4134 19.2503 10.4808 19.2503H17.5192C17.5769 19.2503 17.6298 19.2262 17.6778 19.1781C17.7259 19.1301 17.75 19.0772 17.75 19.0195V9.50029ZM12.053 17.7503H13.1778V11.0003H12.053V17.7503ZM14.8222 17.7503H15.947V11.0003H14.8222V17.7503Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <ShareLessonPop
        show={showShareModal}
        setShow={setShowShareModal}
        lessonId={currentEntry?.id}
      />
      <ShowAttachedFilesPop
        show={showAttachedFileModal}
        setShow={setShowAttachedFileModal}
        files={files}
      />

      <ConfirmationPop
        confirmation={showDeleteModal}
        setConfirmation={setShowDeleteModal}
        type="delete"
        confirmHandler={handleDelete}
      />
      <section className="designations position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Lesson Plans"}
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    searchPlaceholder="Lesson Name / Tag"
                    filterComponent={<>
                      <li>
                        <Dropdown onSelect={(selected) => handleFilterChange("tag_id")([selected])}>
                          <Dropdown.Toggle
                            className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                            variant="transparent"
                            id="dropdown-basic"
                          >
                            <div className="d-flex">
                              <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                                {lessonTags?.records?.find(x => x.id == filter?.tag_id)?.title || "Select Tags"}
                              </div>
                              <span className="icn" style={{ marginRight: "20px" }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </div>
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                            {lessonTags?.records?.length ? lessonTags?.records?.map((item, index) => {
                              return <Dropdown.Item eventKey={item?.id}>{item?.title}</Dropdown.Item>
                            }) : <>
                              <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>

                            </>
                            }
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    </>}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link
                        to={CHATTER_LESSON_PLANS_ADD}
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >
                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add New Lessons
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteLessonLoading) && <LoadingOverlay />}
                    <div className="task_details_table">
                      <TableLayout
                        data={data?.records || []}
                        column={column}
                        // url={CHATTER_EVENT_DETAIL.replace("/:id", "")}
                        handleSort={handleFilterChange("sort")}
                        filter={filter}
                      />
                    </div>
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterLessonPlan;

const Icon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.5">
    <mask id="mask0_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5385_24336)">
      <path d="M3.75 8.99991C3.75 10.1624 4.07812 11.203 4.73438 12.1218C5.39062 13.0405 6.25625 13.6687 7.33125 14.0062C7.55625 14.0812 7.74062 14.2218 7.88437 14.428C8.02812 14.6343 8.1 14.8624 8.1 15.1124C8.1 15.4749 7.94688 15.7624 7.64062 15.9749C7.33437 16.1874 7 16.2312 6.6375 16.1062C5.0875 15.5937 3.84375 14.6874 2.90625 13.3874C1.96875 12.0874 1.5 10.6249 1.5 8.99991C1.5 7.37491 1.96875 5.91241 2.90625 4.61241C3.84375 3.31241 5.0875 2.40616 6.6375 1.89366C7 1.76866 7.33437 1.81241 7.64062 2.02491C7.94688 2.23741 8.1 2.52491 8.1 2.88741C8.1 3.13741 8.02812 3.36554 7.88437 3.57179C7.74062 3.77804 7.55625 3.91866 7.33125 3.99366C6.25625 4.33116 5.39062 4.95929 4.73438 5.87804C4.07812 6.79679 3.75 7.83741 3.75 8.99991ZM14.2875 14.2874C13.8875 14.6999 13.4344 15.0593 12.9281 15.3655C12.4219 15.6718 11.8938 15.9187 11.3438 16.1062C10.9812 16.2312 10.6469 16.1874 10.3406 15.9749C10.0344 15.7624 9.88125 15.4749 9.88125 15.1124C9.88125 14.8624 9.95312 14.6343 10.0969 14.428C10.2406 14.2218 10.425 14.0812 10.65 14.0062C11.0375 13.8812 11.4094 13.7093 11.7656 13.4905C12.1219 13.2718 12.4438 13.0187 12.7313 12.7312C13.0188 12.4312 13.2688 12.1093 13.4813 11.7655C13.6938 11.4218 13.8688 11.0499 14.0063 10.6499C14.0813 10.4249 14.2219 10.2405 14.4281 10.0968C14.6344 9.95304 14.8625 9.88116 15.1125 9.88116C15.475 9.88116 15.7625 10.0343 15.975 10.3405C16.1875 10.6468 16.2313 10.9812 16.1063 11.3437C15.9188 11.8937 15.6719 12.4187 15.3656 12.9187C15.0594 13.4187 14.7 13.8749 14.2875 14.2874ZM14.2875 3.71241C14.7 4.12491 15.0594 4.58116 15.3656 5.08116C15.6719 5.58116 15.9188 6.10616 16.1063 6.65616C16.2313 7.01866 16.1875 7.35304 15.975 7.65929C15.7625 7.96554 15.475 8.11866 15.1125 8.11866C14.8625 8.11866 14.6344 8.04679 14.4281 7.90304C14.2219 7.75929 14.0813 7.57491 14.0063 7.34991C13.8688 6.94991 13.6938 6.57804 13.4813 6.23429C13.2688 5.89054 13.0188 5.56866 12.7313 5.26866C12.4438 4.98116 12.1219 4.72804 11.7656 4.50929C11.4094 4.29054 11.0375 4.11866 10.65 3.99366C10.425 3.91866 10.2406 3.77804 10.0969 3.57179C9.95312 3.36554 9.88125 3.13741 9.88125 2.88741C9.88125 2.52491 10.0344 2.23741 10.3406 2.02491C10.6469 1.81241 10.9812 1.76866 11.3438 1.89366C11.8938 2.08116 12.4219 2.32804 12.9281 2.63429C13.4344 2.94054 13.8875 3.29991 14.2875 3.71241Z" fill="#071E3E" />
      <mask id="mask1_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="3" y="3" width="12" height="12">
        <rect x="3.75" y="3.75" width="10.604" height="10.604" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_5385_24336)">
        <path d="M9.05164 6.84351C8.80863 6.84351 8.6006 6.75698 8.42755 6.58393C8.25449 6.41088 8.16797 6.20285 8.16797 5.95984C8.16797 5.71683 8.25449 5.5088 8.42755 5.33575C8.6006 5.1627 8.80863 5.07617 9.05164 5.07617C9.29464 5.07617 9.50267 5.1627 9.67573 5.33575C9.84878 5.5088 9.9353 5.71683 9.9353 5.95984C9.9353 6.20285 9.84878 6.41088 9.67573 6.58393C9.50267 6.75698 9.29464 6.84351 9.05164 6.84351ZM9.05164 13.0292C8.86754 13.0292 8.71106 12.9647 8.58219 12.8359C8.45332 12.707 8.38889 12.5505 8.38889 12.3664V8.38992C8.38889 8.20583 8.45332 8.04934 8.58219 7.92048C8.71106 7.79161 8.86754 7.72717 9.05164 7.72717C9.23573 7.72717 9.39222 7.79161 9.52108 7.92048C9.64995 8.04934 9.71439 8.20583 9.71439 8.38992V12.3664C9.71439 12.5505 9.64995 12.707 9.52108 12.8359C9.39222 12.9647 9.23573 13.0292 9.05164 13.0292Z" fill="#071E3E" />
      </g>
    </g>
  </g>
</svg>

const ShareIcon = <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="13.5" cy="13.5" r="13.5" fill="#FFE8F8" />
  <mask id="mask0_5486_32941" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="4" y="4" width="18" height="18">
    <rect x="4.65234" y="4.65234" width="17.3477" height="17.3477" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_5486_32941)">
    <path d="M16.9399 20.554C16.3376 20.554 15.8256 20.3432 15.404 19.9216C14.9823 19.4999 14.7715 18.9879 14.7715 18.3856C14.7715 18.3133 14.7896 18.1446 14.8257 17.8796L9.74789 14.916C9.55514 15.0968 9.33227 15.2383 9.07928 15.3407C8.8263 15.4431 8.55524 15.4943 8.26611 15.4943C7.66376 15.4943 7.15177 15.2835 6.73012 14.8618C6.30848 14.4402 6.09766 13.9282 6.09766 13.3258C6.09766 12.7235 6.30848 12.2115 6.73012 11.7899C7.15177 11.3682 7.66376 11.1574 8.26611 11.1574C8.55524 11.1574 8.8263 11.2086 9.07928 11.311C9.33227 11.4134 9.55514 11.5549 9.74789 11.7356L14.8257 8.77209C14.8016 8.68776 14.7865 8.60644 14.7805 8.52814C14.7745 8.44983 14.7715 8.36249 14.7715 8.26611C14.7715 7.66376 14.9823 7.15177 15.404 6.73012C15.8256 6.30848 16.3376 6.09766 16.9399 6.09766C17.5423 6.09766 18.0543 6.30848 18.4759 6.73012C18.8976 7.15177 19.1084 7.66376 19.1084 8.26611C19.1084 8.86846 18.8976 9.38046 18.4759 9.8021C18.0543 10.2237 17.5423 10.4346 16.9399 10.4346C16.6508 10.4346 16.3798 10.3834 16.1268 10.281C15.8738 10.1786 15.6509 10.037 15.4582 9.85632L10.3804 12.8199C10.4045 12.9042 10.4195 12.9855 10.4255 13.0638C10.4316 13.1421 10.4346 13.2295 10.4346 13.3258C10.4346 13.4222 10.4316 13.5096 10.4255 13.5879C10.4195 13.6662 10.4045 13.7475 10.3804 13.8318L15.4582 16.7954C15.6509 16.6147 15.8738 16.4731 16.1268 16.3707C16.3798 16.2683 16.6508 16.2171 16.9399 16.2171C17.5423 16.2171 18.0543 16.4279 18.4759 16.8496C18.8976 17.2712 19.1084 17.7832 19.1084 18.3856C19.1084 18.9879 18.8976 19.4999 18.4759 19.9216C18.0543 20.3432 17.5423 20.554 16.9399 20.554ZM16.9399 19.1084C17.1447 19.1084 17.3164 19.0391 17.455 18.9006C17.5935 18.762 17.6628 18.5904 17.6628 18.3856C17.6628 18.1808 17.5935 18.0091 17.455 17.8706C17.3164 17.732 17.1447 17.6628 16.9399 17.6628C16.7351 17.6628 16.5635 17.732 16.4249 17.8706C16.2864 18.0091 16.2171 18.1808 16.2171 18.3856C16.2171 18.5904 16.2864 18.762 16.4249 18.9006C16.5635 19.0391 16.7351 19.1084 16.9399 19.1084ZM8.26611 14.0487C8.47091 14.0487 8.64258 13.9794 8.78112 13.8409C8.91966 13.7023 8.98893 13.5306 8.98893 13.3258C8.98893 13.121 8.91966 12.9494 8.78112 12.8108C8.64258 12.6723 8.47091 12.603 8.26611 12.603C8.06131 12.603 7.88965 12.6723 7.7511 12.8108C7.61256 12.9494 7.54329 13.121 7.54329 13.3258C7.54329 13.5306 7.61256 13.7023 7.7511 13.8409C7.88965 13.9794 8.06131 14.0487 8.26611 14.0487ZM16.9399 8.98893C17.1447 8.98893 17.3164 8.91966 17.455 8.78112C17.5935 8.64258 17.6628 8.47091 17.6628 8.26611C17.6628 8.06131 17.5935 7.88965 17.455 7.7511C17.3164 7.61256 17.1447 7.54329 16.9399 7.54329C16.7351 7.54329 16.5635 7.61256 16.4249 7.7511C16.2864 7.88965 16.2171 8.06131 16.2171 8.26611C16.2171 8.47091 16.2864 8.64258 16.4249 8.78112C16.5635 8.91966 16.7351 8.98893 16.9399 8.98893Z" fill="#1C1B1F" />
  </g>
</svg>
